import { toast } from 'sonner';
import { useMemo, useState, useEffect, useCallback } from 'react';

import { useTranslate } from 'src/locales';
import { useAppSelector } from 'src/hook/hooks';
import { type RootState } from 'src/redux/store';
import { useChannelContext } from 'src/pages/channel/hooks';

import { getLiveChatScript } from '../../Livechat/utils/getLiveChatScript';

export function useEmailStep5() {
  const { t } = useTranslate('translation');
  const { state, onChangeStep } = useChannelContext();
  const { loginApiData } = useAppSelector((rootState: RootState) => rootState.auth);

  const [websiteDetails, setWebsiteDetails] = useState({
    tenantId: '',
    websiteToken: '',
    authToken: '',
    BASE_URL: '',
    welcomeTitle: '',
    welcomeTagline: '',
    widgetColor: '#000',
  });

  useEffect(() => {
    if (state.channelCreatedResponse) {
      setWebsiteDetails({
        tenantId: state.channelCreatedResponse.config.tenantId,
        authToken: loginApiData && 'token' in loginApiData ? loginApiData.token : '',
        websiteToken: state.channelCreatedResponse.config.settings.websiteToken,
        BASE_URL: state.channelCreatedResponse.config.settings.domainUrl,
        welcomeTagline: state.channelCreatedResponse.config.settings.welcomeTagline || '',
        welcomeTitle: state.channelCreatedResponse.config.settings.welcomeTitle || '',
        widgetColor: state.channelCreatedResponse.config.settings.widgetColor || '#000',
      });
    }
  }, [state.channelCreatedResponse, loginApiData]);

  const codeString = useMemo(
    () => getLiveChatScript('/sdk/chat-agent.js', websiteDetails),
    [websiteDetails]
  );

  const copyText = useCallback(
    (text: string) => {
      const textArea = document.body.appendChild(document.createElement('textarea'));
      textArea.value = text;
      textArea.select();
      try {
        document.execCommand('copy');
        toast.success(t('SCRIPT_COPIED_SUCCESS'));
      } catch (err) {
        console.error('Failed to copy text: ', err);
      } finally {
        document.body.removeChild(textArea);
      }
    },
    [t]
  );

  const copyTextHandler = useCallback(() => {
    copyText(codeString);
  }, [codeString, copyText]);

  return {
    state,
    t,
    codeString,
    copyTextHandler,
    onChangeStep,
  };
}
